import { Center, Portal, Spinner, Stack, Text } from '@chakra-ui/react'
import { motion } from 'framer-motion'

export const AppLoading = () => {
  return (
    <Portal>
      <Center w="100vw" h="100vh" background="neutral.50">
        <motion.div
          animate={{ '--opacity': 1 } as any}
          initial={{ '--opacity': 0 } as any}
          transition={{
            delay: 0.1,
            duration: 0.6,
            loop: Infinity,
          }}
        >
          <Stack
            alignItems="center"
            textAlign="center"
            gap={8}
            opacity={'var(--opacity)'}
          >
            <Spinner
              size="xl"
              emptyColor="gray.200"
              color="primary.800"
              speed="0.7s"
            />
            <Text fontSize="2xl" ml={3} color={'primary.800'}>
              Načítání . . .
            </Text>
          </Stack>
        </motion.div>
      </Center>
    </Portal>
  )
}
